// The dealer's binding of the portal-products host ports to its own Apollo client.
//
// The package takes both product reads and the Configs Service request port as data, so the
// client lives here rather than inside the feature. That injection is also what retired the
// lazy `import('@apollolocal/client')` the old `settings/configServiceClient.ts` needed: the
// client graph reaches authService and through it the Firebase SDK, which wants browser globals
// jsdom does not supply, and the old module was pulled in by `useConfigServiceAdapter` and so by
// every product page. Nothing but DealerAppFrame imports this file now, so a plain import is
// safe — no page test touches the Firebase graph through it.
import client from '@apollolocal/client';
import { createApolloConfigServicePort, createApolloProductFetchers } from '@hopdrive/feature-portal-products';

const fetchers = createApolloProductFetchers(client);

/** The customer's product-access snapshot, through the dealer's client. */
export const fetchProductAccess = fetchers.fetchProductAccess;

/** The dealer-side product inputs for one customer, through the dealer's client. */
export const fetchLocalInputs = fetchers.fetchLocalInputs;

/** Apollo as the Configs Service adapter's one-method request port. */
export const configServicePort = createApolloConfigServicePort(client);
